import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RequiredOutlinedStandard.js";
import o from "../components/PfIcon.js";
const r = (e, t) => {
  const d = {
    ...e,
    ...t.attrs
  };
  return a(o, i(d, {
    icon: n
  }), null);
};
r.displayName = "RequiredOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
